<template>
  <v-snackbar
    v-model="showSnackbar"
    :color="color"
    :multi-line="multiLine"
    :timeout="timeout"
    :centered="centered"
    :left="left"
    :right="right"
    :top="top"
    :elevation="elevation"
    :bottom="bottom"
    data-cy="snackbarToast"
  >
    <span v-dompurify-html="text"></span>
    <template #action="{ attrs }">
      <v-btn v-if="clubEdit" color="white" dark text v-bind="attrs" @click.native="routeTo">
        Setup
      </v-btn>
      <v-btn v-else color="white" dark text v-bind="attrs" @click.native="showSnackbar = false">
        {{ $t('general.close') }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'VtoastComponent',

  data() {
    return {
      multiLine: true,
      showSnackbar: false,
      text: `Unexpected Error`,
      timeout: 6000,
      color: 'error',
      centered: true,
      right: false,
      left: false,
      top: false,
      bottom: false,
      elevation: '16',
      clubEdit: false,
      routeData: null,
    };
  },

  methods: {
    show(data) {
      this.text = data?.text || 'Unexpected Error';
      this.color = data?.color || 'error';
      this.timeout = data?.timeout || 6000;
      this.multiLine = data?.multiLine || true;
      this.centered = data?.centered || true;
      this.elevation = data?.elevation || '16';
      this.right = data?.left ? false : data?.right || false;
      this.left = data?.right ? false : data?.left || false;
      this.top = data?.bottom ? false : data?.top || true;
      this.bottom = data?.top ? false : data?.bottom || false;
      this.showSnackbar = true;
      this.clubEdit = data?.clubEdit || false;
      this.routeData = data?.routeData || null;
    },

    hide() {
      this.showSnackbar = false;
    },

    routeTo() {
      if (this.routeData?.type === 'club_edit') {
        this.$router.push({
          name: 'clubhouseEdit',
          params: {
            clubhouseID: this.routeData?.id,
          },
          query: {
            newClubhouseSetup: true,
          },
        });
        this.showSnackbar = false;
      }
    },
  },
};
</script>

<style scoped>
* >>> .v-snack__content {
  font-size: 1rem;
}

* >>> .v-snack:not(.v-snack--absolute),
* >>> .v-snack,
.v-snack {
  position: fixed !important;
}

@supports (-webkit-touch-callout: none) {
  .v-snack {
    position: fixed !important;
  }
}
</style>
